//#region theme/frontend/islands/pixelate-filter.js
var PIXEL_SIZE = 8;
var ANIM_STEPS = [
	2,
	4,
	6,
	8,
	12,
	16
];
var PixelateFilter = class extends HTMLElement {
	connectedCallback() {
		this._active = false;
		this._raf = null;
		this._createFilter();
		this._onKey = (e) => {
			if (e.key === "p" && !e.metaKey && !e.ctrlKey && !e.altKey) this._active ? this.deactivate() : this.activate();
		};
		document.addEventListener("keydown", this._onKey);
	}
	_createFilter() {
		const ns = "http://www.w3.org/2000/svg";
		this._svg = document.createElementNS(ns, "svg");
		this._svg.setAttribute("style", "position:absolute;width:0;height:0;pointer-events:none");
		const filter = document.createElementNS(ns, "filter");
		filter.id = "pixelate";
		filter.setAttribute("x", "0");
		filter.setAttribute("y", "0");
		this._flood = document.createElementNS(ns, "feFlood");
		this._flood.setAttribute("width", "2");
		this._flood.setAttribute("height", "2");
		this._comp = document.createElementNS(ns, "feComposite");
		const tile = document.createElementNS(ns, "feTile");
		tile.setAttribute("result", "a");
		const sample = document.createElementNS(ns, "feComposite");
		sample.setAttribute("in", "SourceGraphic");
		sample.setAttribute("in2", "a");
		sample.setAttribute("operator", "in");
		this._morph = document.createElementNS(ns, "feMorphology");
		this._morph.setAttribute("operator", "dilate");
		filter.append(this._flood, this._comp, tile, sample, this._morph);
		this._svg.appendChild(filter);
		this._setSize(PIXEL_SIZE);
		document.body.appendChild(this._svg);
	}
	_setSize(size) {
		const half = size / 2;
		this._flood.setAttribute("x", half - 1);
		this._flood.setAttribute("y", half - 1);
		this._comp.setAttribute("width", size);
		this._comp.setAttribute("height", size);
		this._morph.setAttribute("radius", half);
	}
	activate() {
		this._active = true;
		cancelAnimationFrame(this._raf);
		const sizes = ANIM_STEPS;
		let i = 0;
		const step = () => {
			this._setSize(sizes[i]);
			document.documentElement.style.filter = "url(#pixelate)";
			if (++i < sizes.length) this._raf = requestAnimationFrame(step);
		};
		this._raf = requestAnimationFrame(step);
	}
	deactivate() {
		this._active = false;
		cancelAnimationFrame(this._raf);
		const sizes = [...ANIM_STEPS].reverse().slice(1);
		let i = 0;
		const step = () => {
			this._setSize(sizes[i]);
			if (++i < sizes.length) this._raf = requestAnimationFrame(step);
			else document.documentElement.style.filter = "";
		};
		this._raf = requestAnimationFrame(step);
	}
	disconnectedCallback() {
		document.removeEventListener("keydown", this._onKey);
		cancelAnimationFrame(this._raf);
		this._svg?.remove();
		document.documentElement.style.filter = "";
	}
};
customElements.define("pixelate-filter", PixelateFilter);
//#endregion
